module.exports = __webpack_public_path__ + "img/ps-icon.10421eda.jpg";